import React from 'react';
import {
  ArrowDownLeft,
  ArrowUpRight,
  CircleDollarSign,
  RefreshCcw,
  Trophy,
  WalletCards,
} from 'lucide-react';

export type PassbookFilter =
  | 'all'
  | 'bet_placed'
  | 'bet_won'
  | 'bet_lost'
  | 'deposit'
  | 'withdrawal_completed'
  | 'refund'
  | 'reconciliation';

interface PassbookFiltersProps {
  value: PassbookFilter;
  onChange: (value: PassbookFilter) => void;
  disabled?: boolean;
}

const filters = [
  {
    value: 'all',
    label: 'All',
    icon: WalletCards,
    active: 'bg-slate-900 text-white',
  },
  {
    value: 'bet_placed',
    label: 'Bet Placed',
    icon: ArrowUpRight,
    active: 'bg-blue-600 text-white',
  },
  {
    value: 'bet_won',
    label: 'Bet Won',
    icon: Trophy,
    active: 'bg-emerald-600 text-white',
  },
  {
    value: 'bet_lost',
    label: 'Bet Lost',
    icon: ArrowDownLeft,
    active: 'bg-red-600 text-white',
  },
  {
    value: 'deposit',
    label: 'Deposit',
    icon: CircleDollarSign,
    active: 'bg-emerald-600 text-white',
  },
  {
    value: 'withdrawal_completed',
    label: 'Withdrawal',
    icon: WalletCards,
    active: 'bg-purple-600 text-white',
  },
  {
    value: 'refund',
    label: 'Refund',
    icon: CircleDollarSign,
    active: 'bg-cyan-600 text-white',
  },
  {
    value: 'reconciliation',
    label: 'Reconciliation',
    icon: RefreshCcw,
    active: 'bg-amber-600 text-white',
  },
] as const;

const PassbookFilters: React.FC<PassbookFiltersProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <div className="flex flex-wrap gap-2">
      {filters.map((filter) => {
        const Icon = filter.icon;
        const active = value === filter.value;

        return (
          <button
            key={filter.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(filter.value)}
            className={`inline-flex items-center gap-2 rounded-xl border px-4 py-2 text-sm font-medium transition ${
              active
                ? filter.active
                : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'
            } disabled:cursor-not-allowed disabled:opacity-60`}
          >
            <Icon className="h-4 w-4" />
            {filter.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default PassbookFilters;
